import React from 'react';
import { FormikValues } from 'formik';
import { Schema } from 'yup';

import { WizardContext } from 'buyside/components/presentation/Form/Wizard/Wizard';
import { WizardContextProps } from 'interfaces/wizard/wizard';

export interface WizardPageProps {
  children?: React.ReactNode | ((ctx: WizardContextProps) => React.ReactElement);
  validate?: (values: FormikValues) => void;
  validationSchema?: Schema<any>;
}

const WizardPage: React.FunctionComponent<WizardPageProps> = ({ children }): React.ReactElement => {
  if (children && typeof children === 'function') {
    return (
      <WizardContext.Consumer>{(ctx): React.ReactElement => children(ctx)}</WizardContext.Consumer>
    );
  }
  return <>{children}</>;
};

export default WizardPage;
